export const firebaseConfig = {
  apiKey: "AIzaSyAIpzaGbx_mdmdGy-gskvXd2wJ-bsrqmyE",
  authDomain: "help4-4fc63.firebaseapp.com",
  databaseURL: "https://help4-4fc63.firebaseio.com",
  projectId: "help4-4fc63",
  storageBucket: "help4-4fc63.appspot.com",
  messagingSenderId: "490043465022",
  appId: "1:490043465022:web:62c60bb95ca9db78"
}
